import styled from "styled-components";

// theme is now fully typed
export const HeaderWrapper = styled.div`
  display: flex;
  padding: 0 24px;
  height: 68px;
  box-shadow: 0 2px 8px rgb(0 0 0 / 12%);
  z-index: 2;
  background-color: var(--pou-blue-hero, #37a7cd);
  align-items: center;
  position: relative;
  .header {
    &-menu {
      display: flex;
      gap: 20px;
      justify-content: center;
      font-size: 15px;
      font-weight: 600;
      flex: 1;
      .ant-divider-vertical {
        border-left: 1px solid rgba(255, 255, 255, 0.35);
        height: 22px;
        margin: 0 4px;
        top: 0;
      }
      .nav-link {
        color: #ffffff;
        padding: 10px 12px;
        border-radius: 6px;
        transition: all 0.2s ease;
        &:hover {
          color: #f1f5f9;
          background: rgba(255, 255, 255, 0.12);
        }
        &.active {
          background: rgba(255, 255, 255, 0.18);
          border-bottom: 2px solid #ffffff;
          padding-bottom: 8px;
        }
      }
    }
    &-pasydy-logo {
      height: 40px;
      &-name {
        display: flex;
        align-items: center;
        gap: 10px;
        color: #ffffff;
        margin-left: 10px;
      }
    }
    &-mobile-icon {
      position: absolute;
      right: 10px;
      top: 16px;
    }
    &-auth {
      display: flex;
      justify-content: center;
      min-width: 160px;

      .ant-btn {
        height: 34px;
        border-radius: 6px;
        border-color: #ffffff;
        color: #ffffff;
        background: transparent;
        font-weight: 600;
        &:hover {
          background: rgba(255, 255, 255, 0.12);
          color: #ffffff;
          border-color: #ffffff;
        }
      }
    }
    &-phone-number {
      display: flex;
      align-items: center;
      &-icon {
        font-size: 30px;
        color: #fff;
        margin-right: 5px;
        margin-top: -7px;
      }
      &-text {
        color: #fff;
        margin-right: 20px;
        text-align: center;
      }
      &-first {
        font-size: 18px;
        line-height: 18px;
      }
    }
  }
`;
